import React from 'react';
import { Loader2Icon } from 'lucide-react';
type Variant = 'primary' | 'secondary' | 'ghost' | 'dark';
type Size = 'md' | 'lg' | 'sm';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
  icon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  block?: boolean;
}
const variants: Record<Variant, string> = {
  primary: 'bg-pulse-600 text-white hover:bg-pulse-700 shadow-[0_1px_0_rgba(255,255,255,0.15)_inset,0_6px_16px_-6px_rgba(94,69,177,0.6)]',
  dark: 'bg-ink-900 text-white hover:bg-ink-700',
  secondary: 'bg-white text-ink-900 ring-1 ring-inset ring-ink-200 hover:bg-ink-50',
  ghost: 'text-ink-700 hover:bg-ink-100'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-3.5 text-sm gap-1.5 rounded-lg',
  md: 'h-11 px-5 text-[15px] gap-2 rounded-xl',
  lg: 'h-14 px-7 text-base gap-2.5 rounded-2xl'
};
export function Button({
  variant = 'primary',
  size = 'md',
  loading,
  icon,
  trailingIcon,
  block,
  className = '',
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return <button {...rest} disabled={disabled || loading} className={`inline-flex shrink-0 select-none items-center justify-center whitespace-nowrap font-medium transition-[background-color,color,box-shadow,transform,opacity] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pulse-500 focus-visible:ring-offset-2 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50 ${variants[variant]} ${sizes[size]} ${block ? 'w-full' : ''} ${className}`} data-id="element-669" data-mp="eq62ldl0d1pr">
      {loading ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden data-id="element-670" data-mp="1cc3gexog0ivd" /> : icon}
      {children}
      {!loading && trailingIcon}
    </button>;
}